/*
 * @Author: 陈梦男 chenmengnan@piesat.cn
 * @Date: 2023-07-21 13:29:25
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @LastEditTime: 2024-01-17 09:54:14
 * @FilePath: \web\src\components\DataManagement\tradeQuantity\component\config.js
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
const detailTableConfig = [
  {
    title: '序号',
    slots: { customRender: 'serial', },
    ellipsis: true,
    width: 60,
    align: 'center',
  },
  // {
  //   title: '贸易伙伴',
  //   dataIndex: 'tradehb',
  //   ellipsis: true,
  //   align: 'center',
  //   slots: { customRender: 'tradeNation', },
  // },
  {
    title: '进口国',
    dataIndex: 'importCountry',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'importCountry', },
  },
  {
    title: '出口国',
    dataIndex: 'exportCountry',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'exportCountry', },
  },
  {
    title: '数量',
    dataIndex: 'num',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'num', },
  },
  {
    title: '金额',
    dataIndex: 'cost',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'cost', },
  },
  {
    title: '时间',
    dataIndex: 'date',
    ellipsis: true,
    align: 'center',
    slots: { customRender: 'date', },
  },
  // {
  //   title: '备注',
  //   dataIndex: 'remark',
  //   ellipsis: true,
  //   align: 'center',
  //   slots: { customRender: 'remark', },
  //   // width: 200,
  // },
  {
    title: '操作',
    key: 'action',
    slots: { customRender: 'action', },
    align: 'center',
    // width: 180,
  },
];

export {
  detailTableConfig,
};